
(function () {
  'use strict';

  var jsonUrl = window.shipping_json_url; 
  var observer = null; // will hold MutationObserver
  var currentData = null; // keep last used data

  function replaceInText(text, data) {
    var result = String(text || '');
    for (var key in data) {
      if (!Object.prototype.hasOwnProperty.call(data, key)) continue;
      var pattern = 'JSON[' + key + ']';
      if (result.indexOf(pattern) !== -1) {
        result = result.split(pattern).join(String(data[key]));
        // console.log('Replaced', pattern, 'with', data[key]);
      }
    }
    return result;
  }

  function replaceContent(data) {
    if (!data) return 0;
    var replacements = 0;

    // Text nodes
    var walker = document.createTreeWalker(
      document.body,
      NodeFilter.SHOW_TEXT,
      null,
      false
    );

    var textNodes = [];
    var node;
    while ((node = walker.nextNode())) {
      if (node.textContent && node.textContent.indexOf('JSON[') !== -1) {
        textNodes.push(node);
      }
    }

    for (var i = 0; i < textNodes.length; i++) {
      var textNode = textNodes[i];
      var originalText = textNode.textContent;
      var newText = replaceInText(originalText, data);
      if (newText !== originalText) {
        textNode.textContent = newText;
        replacements++;
      }
    }

    // Attributes to check
    var attrList = ['src', 'data-src', 'srcset', 'data-srcset', 'href', 'style'];

    for (var a = 0; a < attrList.length; a++) {
      var attr = attrList[a];
      var elements = document.querySelectorAll('[' + attr + '*="JSON["]');
      for (var j = 0; j < elements.length; j++) {
        var el = elements[j];
        var originalVal = el.getAttribute(attr);
        if (originalVal == null) continue;
        var newVal = replaceInText(originalVal, data);
        if (newVal !== originalVal) {
          el.setAttribute(attr, newVal);
          replacements++;
        }
      }
    }

    return replacements;
  }

  function startObserver() {
    if (observer) return; // already started
    var root = document.body;

    if (!root || root.nodeType !== Node.ELEMENT_NODE) {
      console.warn('MutationObserver not started: document.body unavailable.');
      return;
    }

    var scheduled = false;
    observer = new MutationObserver(function () {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(function () {
        scheduled = false;
        replaceContent(currentData);
      });
    });

    observer.observe(root, {
      childList: true,
      subtree: true,
      characterData: true,
      attributes: true
    });
  }

  function pickMarketData(allData, domain) {
    // exact
    if (allData[domain]) return allData[domain];

    // without www
    var noWww = domain.replace(/^www\./, '');
    if (allData[noWww]) return allData[noWww];
    if (allData['www.' + noWww]) return allData['www.' + noWww];

    // fallback to first
    var keys = Object.keys(allData);
    return keys.length ? allData[keys[0]] : null;
  }

  function init() {
    var domain = window.location.hostname;

    fetch(jsonUrl + '?t=' + Date.now())
      .then(function (response) {
        if (!response.ok) throw new Error('HTTP ' + response.status);
        return response.json();
      })
      .then(function (allData) {
        var data = pickMarketData(allData, domain);
        if (!data) {
          console.warn('No market data found.');
          return;
        }
        currentData = data;

        // initial pass
        replaceContent(currentData);

        // observe future DOM changes
        startObserver();
      })
      .catch(function (error) {
        console.error('Market replacer failed:', error);
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // manual trigger if you ever need it
  window.testMarketReplacer = function () {
    if (currentData) replaceContent(currentData);
  };
})();
